module.exports = __webpack_public_path__ + "media/images/city/012-auspicious-light-pagoda-fe9627ff600cda0484175af2259c7ff2.svg";